export const versionConfig = {
    options: [
        {
            region: 'us',
            language: [
                { value: 'en', label: 'English' },
                { value: 'es', label: 'Spanish' },
            ],
        },
        { region: 'ca', language: [{ value: 'en', label: 'English' }] },
        { region: 'gb', language: [{ value: 'en', label: 'English' }] },
        { region: 'mx', language: [{ value: 'es', label: 'Spanish' }] },
        { region: 'ph', language: [{ value: 'en', label: 'English' }] },
        { region: 'ie', language: [{ value: 'en', label: 'English' }] },
        {
            region: 'un',
            language: [
                { value: 'en', label: 'English' },
                { value: 'es', label: 'Spanish' },
                { value: 'fr', label: 'French' },
                { value: 'pt', label: 'Portuguese' },
            ],
        },
        {
            region: 'ca-qc',
            language: [
                { value: 'en', label: 'English' },
                { value: 'fr', label: 'French' },
            ],
        },
        { region: 'au', language: [{ value: 'en', label: 'English' }] },
    ],
};
export const regionConfig = {
    label: 'Region',
    name: 'region',
    input: 'select',
    options: [
        { label: 'United States', value: 'us' },
        { label: 'Canada', value: 'ca' },
        { label: 'United Kingdom', value: 'gb' },
        { label: 'Mexico', value: 'mx' },
        { label: 'Philippines', value: 'ph' },
        { label: 'Ireland', value: 'ie' },
        { label: 'Universal', value: 'un' },
        { label: 'Quebec', value: 'ca-qc' },
        { label: 'Australia', value: 'au' },
    ],
};
export const languageConfig = {
    label: 'Language',
    name: 'language',
    input: 'select',
    options: [
        { label: 'English', value: 'en' },
        { label: 'Spanish', value: 'es' },
        { label: 'French', value: 'fr' },
        { label: 'Portuguese', value: 'pt' },
    ],
};
export const statusConfig = {
    label: 'Status',
    name: 'status',
    input: 'select',
    options: [
        { label: 'Published', value: 'published' },
        { label: 'Pending', value: 'pending' },
        { label: 'Draft', value: 'draft' },
        { label: 'Trashed', value: 'trash' },
    ],
};
export const categoryTypeConfig = {
    label: 'Category Types',
    name: 'type',
    input: 'select',
    options: [
        { label: 'Category', value: 'category' },
        { label: 'Milestone', value: 'milestone' },
        { label: 'Action Item', value: 'actionItem' },
    ],
};
//# sourceMappingURL=options.js.map